import { render, staticRenderFns } from "./workReportDialog.vue?vue&type=template&id=67febb10&scoped=true&"
import script from "./workReportDialog.vue?vue&type=script&lang=js&"
export * from "./workReportDialog.vue?vue&type=script&lang=js&"
import style0 from "./workReportDialog.vue?vue&type=style&index=0&id=67febb10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67febb10",
  null
  
)

export default component.exports